import { InfoClientType } from '../users/types';

export interface TPrivateChatState {
  privateChats: TPrivateChat[] | null;
  currentUserId2: string | null | undefined;
  readonly loading: boolean;
  readonly errors?: string | undefined;
}

export interface TPrivateChat {
  eventId: number;
  roomId: number;
  userId2: string;
  userId1: string;
  adate: Date;
  isShow2: number;
  isShow1: number;
  client: InfoClientType;
  messages: TPrivateMessage[];
}

export interface TPrivateMessage {
  absnum: number;
  roomId: number;
  userId1: string;
  userId2: string;
  name: string;
  message: string;
  countLike?: number;
  comment: { name: string; message: string } | null;
  adate: Date;
  typeId: number;
}

enum ActionTypes {
  GET_PRIVATE_CHATS_R = '@@privateChat/GET_PRIVATE_CHATS_R',
  GET_PRIVATE_CHATS_S = '@@privateChat/GET_PRIVATE_CHATS_S',
  GET_PRIVATE_CHATS_E = '@@privateChat/GET_PRIVATE_CHATS_E',

  OPEN_PRIVATE_CHAT_R = '@@privateChat/OPEN_PRIVATE_CHAT_R',
  OPEN_PRIVATE_CHAT_S = '@@privateChat/OPEN_PRIVATE_CHAT_S',
  OPEN_PRIVATE_CHAT_E = '@@privateChat/OPEN_PRIVATE_CHAT_E',

  CLOSE_PRIVATE_CHAT_R = '@@privateChat/CLOSE_PRIVATE_CHAT_R',
  CLOSE_PRIVATE_CHAT_S = '@@privateChat/CLOSE_PRIVATE_CHAT_S',
  CLOSE_PRIVATE_CHAT_E = '@@privateChat/CLOSE_PRIVATE_CHAT_E',

  SEND_PRIVATE_MESSAGE_R = '@@privateChat/SEND_PRIVATE_MESSAGE_R',
  SEND_PRIVATE_MESSAGE_S = '@@privateChat/SEND_PRIVATE_MESSAGE_S',
  SEND_PRIVATE_MESSAGE_E = '@@privateChat/SEND_PRIVATE_MESSAGE_E',

  SET_CREATED_PRIVATE_CHAT = '@@privateChat/SET_CREATED_PRIVATE_CHAT',
  SET_NEW_PRIVATE_MESSAGE = '@@privateChat/SET_NEW_PRIVATE_MESSAGE',
  SET_CURRENT_USER_ID2 = '@@privateChat/SET_CURRENT_USER_ID2',
}

export default ActionTypes;
